import { COLORS } from '@enums/colors'
import { shadows } from '@util/shadows'
import styled, { createGlobalStyle } from 'styled-components'

export const Container = styled.div`
  background: ${COLORS.white};
  height: 100%;
`

type SidenavProps = {
  isOpened: boolean
  width?: string
}

export const SidenavMenuContainer = styled.div<SidenavProps>`
  background: ${COLORS.white};
  position: fixed;
  z-index: 3;
  box-shadow: ${shadows.default};
  min-width: ${({ width }) => width || '16.25rem'};
  height: 100vh;
  transform: ${({ isOpened }) => isOpened ? 'translateX(0)'  : 'translateX(calc(-100% - 20px))'};

  -webkit-transition: .25s ease-out;
  -moz-transition: .25s ease-out;
  -o-transition: .25s ease-out;
  transition: .25s ease-out;
`

type SidenavContentBackdropProps = {
  isOverMode?: boolean
}

export const SidenavContentBackdrop = styled.div<SidenavContentBackdropProps>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: ${({ isOverMode }) => isOverMode && 'rgba(0,0,0,0.3)'};
  z-index: 2;
`

export const NoScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`

type SidenavContentContainerProps = {
  isOpened: boolean
  isOverMode?: boolean
  isSemiSideMode?: boolean
  isSideMode?: boolean
}

export const SidenavContentContainer = styled.div<SidenavContentContainerProps>`
  -webkit-transition: .25s ease-out;
  -moz-transition: .25s ease-out;
  -o-transition: .25s ease-out;
  transition: .25s ease-out;
  margin-left: ${({ isOpened, isSideMode }) => isOpened && isSideMode ? '288px' : 0};
  transform: ${({ isOpened, isSemiSideMode }) => isOpened && isSemiSideMode ? 'translateX(180px)'  : 'translateX(0)'};
`
